import {
    Drawer,
    Tooltip,
    Button,
    IconButton,
    Typography,
    Toolbar,
} from '@mui/material'
import {
    NotificationsActive as NotificationsActiveIcon,
    NotificationsOff as NotificationsOffIcon,
    Close as CloseIcon,
} from '@mui/icons-material'
import { Grid } from '../UniversalComponents'
import UserNotifications from '../UserNotifications'
import { UniversalAccordion } from '../UniversalComponents/UniversalFormStyles'
import { editUser } from '../../apiRoutes'
import { useEffect, useReducer } from 'react'

const NavMenuNotificationsModal = ({
    open,
    onClose,
    userNotifications,
    onClearNotifications,
    handleDeleteNotification,
    handleMarkAsRead,

    disableNotifications,
    notificationsEnabled,
    setUserNotifications,
    user,
    setToastMessage,
}) => {
    // const newNotifications = userNotifications?.filter((n) => !n.read)
    // const readNotifications = userNotifications?.filter((n) => n.read)

    const defaultState = {
        notifications: userNotifications,
        readNotifications: [],
        unreadNotification: [],
    }
    const reducer = (oldState: any, newState: any) => ({
        ...oldState,
        ...newState,
    })
    const [state, setState] = useReducer(reducer, defaultState)

    const { notifications, readNotifications, unreadNotification = [] } = state
    const newNotificationsKey = `new-notifs-${
        unreadNotification?.length || 0
    }-${Date.now()}`

    const handleToggleRead = async (notificationId: string) => {
        try {
            const updatedNotifications = userNotifications?.map((n: any) =>
                n._id === notificationId ? { ...n, read: !n.read } : n
            )

            const cleanUpdatedNotifications = userNotifications?.map(
                ({ _id, read }: any) => ({
                    _id,
                    read:
                        _id === notificationId
                            ? read === true
                                ? false
                                : true
                            : false,
                })
            )

            const readNotifications = updatedNotifications?.filter(
                (read) => read?.read === true
            )

            await editUser({
                // ...user,
                id: user._id,
                userNotifications: cleanUpdatedNotifications,
            })
            setState({ readNotifications: readNotifications })
            setUserNotifications(updatedNotifications)
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    const handleMarkAllRead = async () => {
        try {
            const updateNotifications = userNotifications?.map((n: any) => ({
                ...n,
                read: true,
            }))

            const updatedNotifications = userNotifications?.map(
                ({ _id, read }: any) => ({
                    _id,
                    read: true,
                })
            )

            await editUser({
                // ...user,
                id: user._id,
                userNotifications: updatedNotifications,
            })

            setState({
                readNotifications: updatedNotifications,
                notifications: updateNotifications,
            })

            setUserNotifications(updateNotifications)
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    const handleDeleteAllRead = async () => {
        try {
            const deleteReadNotifications = unreadNotification?.map(
                ({ _id }: any) => ({
                    _id,
                })
            )

            await editUser({
                // ...user,
                id: user._id,
                userNotifications: deleteReadNotifications,
            })

            setState({ readNotifications: [] })
            setUserNotifications(unreadNotification)
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    useEffect(() => {
        if (userNotifications) {
            const newNotifications = userNotifications?.filter((n) => !n.read)
            const readNotifications = userNotifications?.filter((n) => n.read)

            setState({
                readNotifications: readNotifications,
                unreadNotification: newNotifications,
            })
        }
    }, [userNotifications])

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Toolbar
                sx={{
                    background: 'rgb(33,33,33)',
                    padding: 6,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant="h4" color="primary">
                    Notification Center
                </Typography>
                <div>
                    <Tooltip
                        title={
                            notificationsEnabled
                                ? 'Disable Notifications'
                                : 'Enable Notifications'
                        }
                    >
                        <IconButton
                            onClick={disableNotifications}
                            sx={{ color: 'primary' }}
                        >
                            {notificationsEnabled ? (
                                <NotificationsActiveIcon />
                            ) : (
                                <NotificationsOffIcon />
                            )}
                        </IconButton>
                    </Tooltip>
                    <IconButton onClick={onClose} color="primary">
                        <CloseIcon />
                    </IconButton>
                </div>
            </Toolbar>

            <Grid
                container
                sx={{ padding: 3, background: 'rgb(33,33,33)', width: 600 }}
            >
                <UniversalAccordion
                    accordionTitle={`New Notifications (${
                        unreadNotification?.length || 0
                    })`}
                    sx={{ scrollX: 'expanded' }}
                    key={`new-${unreadNotification?.length || 0}`}
                    defaultExpanded={unreadNotification?.length > 0}
                >
                    <UserNotifications
                        userNotifications={unreadNotification}
                        handleDeleteNotification={handleDeleteNotification}
                        handleMarkAsRead={handleToggleRead}
                    />
                </UniversalAccordion>

                <UniversalAccordion accordionTitle="Read Notifications">
                    <UserNotifications
                        userNotifications={readNotifications}
                        handleDeleteNotification={handleDeleteNotification}
                        handleMarkAsRead={handleToggleRead}
                    />
                </UniversalAccordion>

                <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: 2, marginBottom: 2 }}
                >
                    <Grid item xs={6}>
                        <Button
                            sx={{ height: 55, width: 270 }}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleMarkAllRead}
                            disabled={unreadNotification?.length === 0}
                        >
                            Mark All Read
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            sx={{ height: 55, width: 270 }}
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleDeleteAllRead}
                            disabled={readNotifications?.length === 0}
                        >
                            Delete All Read
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Drawer>
    )
}

export default NavMenuNotificationsModal
